import { INFORMATION_PATH } from 'simcards/navigation';

module.exports = {
  path: INFORMATION_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/SimcardInformation'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/simcards/routes/show/routes/information/index.js